Object.assign = require('object-assign');
